import { computed } from 'vue';
import { useStore } from './store';

/**
 * Composable for accessing Flipper feature flags in widget
 * @returns {Object} Object containing:
 *   - isEnabled(flagName): Check if a flag is enabled
 *   - flags: All enabled flags
 *   - hasFetched: Whether flags have been fetched
 * @example
 * const { isEnabled, flags } = useFlipper();
 * if (isEnabled('chat_widget_v2').value) { ... }
 */
export const useFlipper = () => {
  const store = useStore();

  const flags = computed(() => store.getters['flipperFeatures/getFlags']);
  const hasFetched = computed(
    () => store.getters['flipperFeatures/getHasFetched']
  );

  const isEnabled = flagName => {
    return computed(() => store.getters['flipperFeatures/isEnabled'](flagName));
  };

  return {
    isEnabled,
    flags,
    hasFetched,
  };
};
